import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form', 'maleRadioInput', 'femaleRadioInput']

  formSubmit() {
    this.formTarget.requestSubmit()
  }

  checkedRadio(event) {
    const radioInput = event.currentTarget.parentNode.querySelector('input')
    const isDisabled = radioInput.getAttribute('disabled') === 'disabled'
    const isChecked = radioInput.getAttribute('checked') === 'checked'

    if (!isDisabled && !isChecked) {
      radioInput.setAttribute('checked', true)
      this.formSubmit()
    }
  }

  selectChanged(event) {
    const item = event.params.selectedItem
    const selectedOption = event.currentTarget.value

    if (item === 'inquiryGenre' && selectedOption === 'female') {
      this.genderFemaleChecked()
    }

    this.formSubmit()
  }

  genderFemaleChecked() {
    if (!this.hasMaleRadioInputTarget) return

    const isMaleChecked =
      this.maleRadioInputTarget.parentNode
        .querySelector('input')
        .getAttribute('checked') === 'checked'

    if (isMaleChecked) {
      this.maleRadioInputTarget.setAttribute('disabled', 'disabled')
      this.maleRadioInputTarget.setAttribute('checked', false)
      this.femaleRadioInputTarget.setAttribute('checked', true)
    }
  }
}
